var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mavon-editor',{attrs:{"value":_vm.value,"toolbarsFlag":false,"subfield":false,"codeStyle":"vs2015","defaultOpen":"preview"}})}
var staticRenderFns = []

export { render, staticRenderFns }